import React from "react";
import { Helmet } from "react-helmet";
import { Grid } from "@mui/material";
import { useParams } from "react-router";
import EditAccountForm from "../../components/EditAccountForm";
import { mainBackgroundStyles } from "../../styles/common";

function EditAccount() {
  const params = useParams();
  const accountId = params && params.id;

  return (
    <>
      <Helmet>
        <title>{accountId ? "Update Account" : "Create Account"}</title>
      </Helmet>
      <Grid
        container
        spacing={0}
        sx={mainBackgroundStyles}
      >
        <EditAccountForm />
      </Grid>
    </>
  );
}

export default EditAccount;
